<ng-container *ngIf="nextRound">
    <p>{{title ? title + ":" : ''}}
    <span class="rounds" *ngIf="!nextRound.break">{{nextRound.blinds.smallBlind}} / {{nextRound.blinds.bigBlind}}</span>
    <span class="break" *ngIf="nextRound.break">Break</span>
    </p>
</ng-container>